import { useState } from "react";
import { api } from "../api";
import {
  Dialog,
  DialogActions,
  DialogBody,
  DialogTitle,
} from "./tailwind/dialog";
import { Button } from "./tailwind/button";
import AutocompleteInput from "./tailwind/autocomplete-input";

export const TagMergeDialog = ({
  open,
  tagToMerge,
  setTagToMerge,
  tags,
  setMergingTagIds,
  customerId,
}) => {
  const [targetTagId, setTargetTagId] = useState("");
  const [mergeSearch, setMergeSearch] = useState("");

  const [isMergeLoading, setIsMergeLoading] = useState(false);

  const handleMergeCancel = () => {
    setTagToMerge(null);
    setTargetTagId("");
    setMergeSearch("");
    setTagToMerge(null);
  };

  const handleMergeConfirm = async () => {
    setIsMergeLoading(true);
    setMergingTagIds((ids) => [...ids, tagToMerge.id]);
    try {
      api.mergeTags({
        mergedTagId: tagToMerge.id,
        targetTagId: targetTagId,
        customerId: customerId,
      });

      await api.tag.delete(targetTagId);

      // Data will be refreshed automatically by useFindMany
      setTagToMerge(null);
      setTargetTagId("");
      setMergeSearch("");
    } catch (e) {
      console.error(e);
    }
    setIsMergeLoading(false);
  };

  const mergeOptions = tags.filter(
    (t) =>
      t.id !== tagToMerge?.id &&
      t.name.toLowerCase().includes(mergeSearch.toLowerCase()),
  );
  return (
    <Dialog
      key="dialog_merge_tag"
      open={open}
      onClose={() => handleMergeCancel()}
    >
      <DialogTitle>Merge tag</DialogTitle>
      <DialogBody>
        <p>
          Select the tag to merge <b>{tagToMerge?.name}</b> with:
        </p>
        <div className="mt-4">
          <AutocompleteInput
            value={mergeSearch}
            onChange={setMergeSearch}
            options={mergeOptions.map((t) => ({
              value: t.id,
              label: t.name,
            }))}
            selected={
              targetTagId
                ? [mergeOptions.find((t) => t.id === targetTagId)]
                    .filter(Boolean)
                    .map((t) => ({
                      value: t.id,
                      label: t.name,
                    }))
                : []
            }
            onSelect={(option) => {
              setTargetTagId(option.value);
            }}
            placeholder="Search tag..."
          />
          {isMergeLoading && (
            <p className="mt-4 text-yellow-700">
              Please wait, merging tags may take a few seconds...
            </p>
          )}
        </div>
      </DialogBody>
      <DialogActions>
        <Button
          color="secondaryButton"
          onClick={() => handleMergeCancel()}
          className="min-w-[100px] h-10"
          disabled={isMergeLoading}
        >
          Cancel
        </Button>
        <Button
          color="primaryButton"
          onClick={() => handleMergeConfirm()}
          className="min-w-[100px] h-10"
          disabled={!targetTagId || isMergeLoading}
          loading={isMergeLoading}
        >
          Merge
        </Button>
      </DialogActions>
    </Dialog>
  );
};
